import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate, translate} from "react-i18nify";

import imgSearch from "../../../../resources/img/svgicons/search.svg";
import imgClose from "../../../../resources/img/svgicons/close-black.svg";
import imgCustomer from "../../../../resources/img/svgicons/customer.svg";
import imgAddCustomer from "../../../../resources/img/svgicons/customers-add.svg";

import Customer from "../../../../models/entities/Customer";
import Modal from "../../../global/generic/Modal";
import Input from "../../../global/generic/Input";
import Button, {BUTTON_SMALL} from "../../../global/generic/Button";

import * as componentTypes from "../../../../constants/componentTypes";
import * as navigationActions from "../../../../actions/navigationActions";
import * as actions from "../../../../actions/customersActions";
import * as config from "../../../../constants/config";
import * as validationHelper from "../../../../helpers/validationHelper";
import * as modelHelper from "../../../../helpers/modelHelper";
import CancelButton from "../../../global/generic/CancelButton";
import Table from "../../../global/generic/Table";

class CustomersModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            customerName: "",
            customerPhone: "",
            customerEmail: "",
            customerStreet: "",
            customerCity: "",
            customerCountry: "",
            customerZipCode: "",
            customerBarcode: "",
            selectedCustomerId: this.props.oldCustomer?.id,
            phoneValidation: true,
            emailValidation: true,
            marginSelectBoxValue: "none",
            identification: ""
        };
    }

    componentDidMount = () => {
        this.props.dispatchGetLastCustomers(this.props.tabId, 0);

        let self = this;
        window.jQuery("#customer-search-input").focus();
        window.jQuery(".general-table-content").scroll(function () {
            let selectItem = window.jQuery(".general-table-content .general-table-row ");
            let contentHeight = selectItem.outerHeight() * self.props.customerList.length;
            let scrollPosition =
                window.jQuery(this).scrollTop() + window.jQuery(".general-table-content").outerHeight();

            if (scrollPosition >= contentHeight - 50 && self.props.offset <= self.props.customerList.length) {
                self.props.dispatchReloadCustomerListAction(self.props.tabId, self.props.filter, self.props.offset);

                self.props.dispatchChangeCustomerOffset(
                    self.props.tabId,
                    self.props.offset + config.MAX_CUSTOMER_LIMIT
                );
            }
        });
    };

    componentDidUpdate = (prevProps) => {
        if (this.props.filter !== prevProps.filter) {
            window.jQuery(".general-table-content").scrollTop(0);
        }

        if (this.props.customerList.length !== prevProps.customerList.length) {
            this.props.dispatchChangeCustomerOffset(this.props.tabId, this.props.customerList.length);
        }
    };

    componentWillUnmount = () => {
        this.props.dispatchChangeCustomerFilter(this.props.tabId, "");
        window.jQuery(".general-table-content").unbind("scroll");
    };

    handleCloseModalClick = () => {
        this.props.dispatchCloseCustomersModalAction();
    };

    handleCustomerNameChange = (event) => {
        this.setState({customerName: event.target.value});
    };

    handleCustomerPhoneChange = (event) => {
        this.setState({
            customerPhone: event.target.value,
            phoneValidation: validationHelper.isPhoneValid(event.target.value)
        });
    };

    handleCustomerEmailChange = (event) => {
        this.setState({
            customerEmail: event.target.value,
            emailValidation: validationHelper.isEmailValid(event.target.value)
        });
    };

    handleCustomerStreetChange = (event) => {
        this.setState({customerStreet: event.target.value});
    };

    handleCustomerCityChange = (event) => {
        this.setState({customerCity: event.target.value});
    };

    handleCustomerCountryChange = (event) => {
        this.setState({customerCountry: event.target.value});
    };

    handleCustomerZipCodeChange = (event) => {
        this.setState({customerZipCode: event.target.value});
    };

    handleCustomerBarcodeChange = (event) => {
        this.setState({customerBarcode: event.target.value});
    };

    handleCreateCustomerClick = () => {
        let customer = new Customer(-1, this.state.customerName);
        customer.email = this.state.customerEmail;
        customer.phone = this.state.customerPhone;
        customer.city = this.state.customerCity;
        customer.country = this.state.customerCountry;
        customer.street = this.state.customerStreet;
        customer.zipCode = this.state.customerZipCode;
        customer.barcode = this.state.customerBarcode;
        customer.margin = this.state.marginSelectBoxValue === "none" ? null : Number(this.state.marginSelectBoxValue);
        customer.identification = this.state.identification;

        this.props.dispatchCreateAndSelectCustomerAction(this.props.tabId, customer);
        this.props.dispatchChangeCustomerOffset(this.props.tabId, config.MAX_CUSTOMER_LIMIT);
        this.props.dispatchChangeCustomerFilter(this.props.tabId, "");
    };

    handleSelectCustomerClick = () => {
        this.props.dispatchSelectCustomerAction(this.props.tabId, this.state.selectedCustomerId);
    };

    handleCustomerSearchInputChange = (event) => {
        this.props.dispatchChangeCustomerFilter(this.props.tabId, event.target.value);
        this.props.dispatchGetCustomerListAction(this.props.tabId, event.target.value);
        this.setState({selectedCustomerId: null});
    };

    handleCustomerClick = (customerId) => {
        this.setState({selectedCustomerId: Number(customerId)});
    };

    handleCustomerDoubleClick = (customerId) => {
        this.props.dispatchSelectCustomerAction(this.props.tabId, Number(customerId));
    };

    handleInputFocus = (event) => {
        event.target.select();
    };

    handleClearInputClick = () => {
        this.props.dispatchResetFilterAction(this.props.tabId);
    };

    handleMarginSelectBoxChanged = (event) => {
        this.setState({
            marginSelectBoxValue: event.target.value
        });
    };

    handleIdentificationChange = (event) => {
        if (validationHelper.isIntegerValueValid(event.target.value) && event.target.value.length < 20) {
            this.setState({identification: event.target.value});
        }
    };

    getSelectBoxOptions = () => {
        let options = [];
        options.push(
            <option key="none" value="none">
                -
            </option>
        );

        for (let margin of this.props.marginList) {
            options.push(
                <option key={margin.id} value={margin.id}>
                    {margin.name}
                </option>
            );
        }

        return options;
    };

    getCustomerListSection = () => {
        return (
            <div className="col-6 flex flex-column padding-left-10">
                <Translate className="col-12 font-size-1_25em color-primary" value="customersTab.listOfCustomers" />
                <Input
                    id="customer-search-input"
                    className="primary-input col-12"
                    type="text"
                    value={this.props.filter}
                    onChange={this.handleCustomerSearchInputChange}
                    onFocus={this.handleInputFocus}
                    svgBefore={imgSearch}
                    svgAfter={this.props.filter ? imgClose : null}
                    svgAfterAction={this.handleClearInputClick}
                />
                <Table
                    className="fill-flex-space margin-top-5"
                    tableHeader={modelHelper.buildTableRow([modelHelper.buildTableCell(translate("general.name"))])}
                    tableRows={this.props.customerList.map((customer) => {
                        return modelHelper.buildTableRow(
                            [modelHelper.buildTableCell(customer.name)],
                            customer.id === this.state.selectedCustomerId ? "active" : "",
                            customer.id,
                            {
                                onClick: () => this.handleCustomerClick(customer.id),
                                onDoubleClick: () => this.handleCustomerDoubleClick(customer.id)
                            }
                        );
                    })}
                    tableColumns={[modelHelper.buildTableColumn("col-6")]}
                />
                <div className="col-12 flex flex-wrap margin-top-10 flex-end">
                    <Button
                        size={BUTTON_SMALL}
                        label={<Translate value="customersTab.selectCustomer" />}
                        svgBefore={imgCustomer}
                        disabled={!this.state.selectedCustomerId}
                        onClick={this.handleSelectCustomerClick}
                    />
                    <CancelButton className="margin-left-5" size={BUTTON_SMALL} onClick={this.handleCloseModalClick} />
                </div>
            </div>
        );
    };

    getLabelInputRow = (translation, required, value, onChangeFunction, isValidBoolean) => {
        return (
            <div className="col-12 flex flex-wrap flex-align-center-vertical">
                <div className="col-4 flex">
                    <Translate value={translation} />
                    {required ? "*" : null}:
                </div>
                <Input
                    className="col-8 primary-input"
                    value={value}
                    onChange={onChangeFunction}
                    isValid={isValidBoolean}
                />
            </div>
        );
    };

    getAddCustomerSection = () => {
        return (
            <div className="col-6 flex flex-column padding-right-10 slim-scroll">
                <Translate className="col-12 font-size-1_25em color-primary" value="customersTab.information" />
                <div className="col-12 flex flex-wrap flex-row-gap-0_6rem padding-bottom-10">
                    {this.getLabelInputRow(
                        "general.name",
                        true,
                        this.state.customerName,
                        this.handleCustomerNameChange
                    )}
                    {this.getLabelInputRow(
                        "general.phone",
                        false,
                        this.state.customerPhone,
                        this.handleCustomerPhoneChange,
                        this.state.phoneValidation
                    )}
                    {this.getLabelInputRow(
                        "general.email",
                        false,
                        this.state.customerEmail,
                        this.handleCustomerEmailChange,
                        this.state.emailValidation
                    )}
                    {this.getLabelInputRow(
                        "general.street",
                        false,
                        this.state.customerStreet,
                        this.handleCustomerStreetChange
                    )}
                    {this.getLabelInputRow(
                        "general.city",
                        false,
                        this.state.customerCity,
                        this.handleCustomerCityChange
                    )}
                    {this.getLabelInputRow(
                        "general.country",
                        false,
                        this.state.customerCountry,
                        this.handleCustomerCountryChange
                    )}
                    {this.getLabelInputRow(
                        "customersTab.zipCode",
                        false,
                        this.state.customerZipCode,
                        this.handleCustomerZipCodeChange
                    )}
                    {this.getLabelInputRow(
                        "customersTab.identificationNumber",
                        false,
                        this.state.identification,
                        this.handleIdentificationChange
                    )}
                    {this.getLabelInputRow(
                        "navigation.navBar.barcode",
                        false,
                        this.state.customerBarcode,
                        this.handleCustomerBarcodeChange
                    )}
                </div>
                <Translate
                    className="padding-top-10 col-12 font-size-1_25em color-primary"
                    value="customersTab.additionalSettings"
                />
                <div className="col-12 flex flex-wrap flex-align-center-vertical">
                    <div className="col-4">
                        <Translate value="general.margin" />:
                    </div>
                    <div className="col-8 flex flex-wrap flex-row-gap-10px">
                        <select
                            className="col-12 primary-select"
                            value={this.state.marginSelectBoxValue}
                            onChange={this.handleMarginSelectBoxChanged}
                        >
                            {this.getSelectBoxOptions()}
                        </select>
                    </div>
                </div>

                {
                    <div className="padding-top-10 flex-right flex-bottom">
                        <Button
                            label={<Translate value="customersTab.createAndSelect" />}
                            size={BUTTON_SMALL}
                            svgBefore={imgAddCustomer}
                            onClick={this.handleCreateCustomerClick}
                            disabled={
                                this.state.customerName === "" ||
                                !this.state.phoneValidation ||
                                !this.state.emailValidation
                            }
                        />
                    </div>
                }
            </div>
        );
    };

    getContent = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                {this.getAddCustomerSection()}
                {this.getCustomerListSection()}
            </React.Fragment>,
            "slim-scroll"
        );
    };

    render() {
        return (
            <Modal
                className={this.props.local ? "custom-formula" : null}
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(<Translate value="customersTab.addCustomer" />)}
                content={this.getContent()}
                styles={{minWidth: "60%", maxHeight: "70%"}}
            />
        );
    }
}

const mapStoreToProps = (store, ownProps) => {
    if (store.customers[ownProps.tabId] === undefined) {
        return {
            customerList: [],
            lastCustomerList: [],
            filter: "",
            offset: config.MAX_CUSTOMER_LIMIT,
            marginList: store.global.customMarginList,
            oldCustomer: null,
            local: store.searchPanel[ownProps.tabId]?.local
        };
    }

    return {
        customerList: store.customers[ownProps.tabId].customerList,
        lastCustomerList: store.customers[ownProps.tabId].lastCustomerList,
        filter: store.customers[ownProps.tabId].filter,
        offset: store.customers[ownProps.tabId].offset,
        marginList: store.global.customMarginList,
        oldCustomer: store.customers[ownProps.tabId].customer,
        local: store.searchPanel[ownProps.tabId]?.local
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseCustomersModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.CUSTOMERS_MODAL));
        },
        dispatchGetCustomerListAction: (tabId, filter) => {
            dispatch(actions.getCustomers(tabId, filter));
        },
        dispatchReloadCustomerListAction: (tabId, filter, offset) => {
            dispatch(actions.reloadCustomers(tabId, filter, offset));
        },
        dispatchCreateAndSelectCustomerAction: (tabId, customer) => {
            dispatch(actions.addCustomer(tabId, customer));
        },
        dispatchSelectCustomerAction: (tabId, customerId) => {
            dispatch(actions.selectCustomer(tabId, customerId));
        },
        dispatchChangeCustomerFilter: (tabId, filter) => {
            dispatch(actions.changeFilter(tabId, filter));
        },
        dispatchChangeCustomerOffset: (tabId, offset) => {
            dispatch(actions.changeOffset(tabId, offset));
        },
        dispatchGetLastCustomers: (tabId, offset) => {
            dispatch(actions.getLastCustomers(tabId, offset));
        },
        dispatchResetFilterAction: (tabId) => {
            dispatch(actions.getCustomers(tabId, ""));
            dispatch(actions.changeFilter(tabId, ""));
        }
    };
};

export default CustomersModal = connect(mapStoreToProps, mapDispatchToProps)(CustomersModal);
